import { render } from "./photoDefect.vue?vue&type=template&id=cbca5168&scoped=true&ts=true"
import script from "./photoDefect.vue?vue&type=script&lang=ts"
export * from "./photoDefect.vue?vue&type=script&lang=ts"

import "./photoDefect.vue?vue&type=style&index=0&id=cbca5168&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbca5168"]])

export default __exports__